import { em } from 'polished'
import styled, { css } from 'styled-components'

import { BadgeStyled } from '../../../elements/LegacyBadge'
import { MediaStyled } from '../../../elements/Media/styles/MediaStyled'

interface IMediaGroupStyled {
  count?: number
}

export const MediaGroupStyled = styled.div<IMediaGroupStyled>`
  /* stylelint-disable */
  display: inline-block;
  position: relative;

  width: ${em(52)};
  height: ${em(52)};

  ${MediaStyled} {
    transform-origin: left top;
    position: absolute;
    top: 0;
    margin: 0;

    display: none;

    ${(props) => {
      if (props.count > 1) {
        return 'transform: scale(.75)'
      }
    }}
  }

  ${MediaStyled}:nth-child(1), ${MediaStyled}:nth-child(2), ${MediaStyled}:nth-child(3) {
    display: block;
  }

  ${BadgeStyled} {
    position: absolute;
    bottom: -5px;
    right: -5px;
  }

  ${(props) => {
    if (props.count >= 3) {
      return css`
        ${MediaStyled}:nth-child(2) {
          margin-top: ${em(6)};
          margin-left: ${em(6)};
        }

        ${MediaStyled}:nth-child(3) {
          margin-top: ${em(12)};
          margin-left: ${em(12)};
        }
      `
    } else if (props.count === 2) {
      return css`
        ${MediaStyled}:nth-child(2) {
          margin-top: ${em(12)};
          margin-left: ${em(12)};
        }
      `
    }
  }}
`
